import { buildUrl } from '@wix/cashier-common/dist/src/utils/buildUrl';
import { Routes } from '../server/constants';

const BASE_URL = window.document.location.origin + window.document.location.pathname;

export const getAddPaymentMethodUrl = (params: { startLoadTime?: number; appSessionId?: string }): string =>
  buildUrl(`${BASE_URL}${Routes.addNewPaymentMethod}`, params).toString();

export const getDeleteCardConfirmationUrl = (params: {
  startLoadTime?: number;
  savedPaymentMethodId?: string;
  appSessionId?: string;
  subscriptionsAmount?: number;
}): string => buildUrl(`${BASE_URL}${Routes.deleteCardModal}`, params).toString();
